module.exports = __webpack_public_path__ + "static/img/h6-1.939788f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd101/h6-1.png
// module id = /zVr
// module chunks = 1